import axios from 'axios';
import store from '../../store/index';

export default {
	getAdapters(showDeleted) {
		return axios.get(`/api/adapters?deleted=${showDeleted}`);
	},
	getAdapter(adapterId) {
		return axios.get(`/api/adapters/${adapterId}`);
	},
	editAdapter(adapter) {
		return axios.patch(`/api/adapters/${adapter.id}`, adapter);
	},
	createAdapter(adapter) {
		return axios.post(`/api/adapters`, adapter);
	},
	deleteAdapter(adapter) {
		return axios.delete(`/api/adapters/${adapter.id}`);
	},
	loadAdapter(id) {
		return axios.get(`/api/adapters/${id}`);
	},
	runAdapter(id, reset) {
		const resetValue = reset ? 1 : 0;
		return axios.post(`/api/adapters/${id}?reset=${resetValue}`, null);
	},
	getAdapterRuns(id, limit, offset) {
		return axios.get(`/api/adapters/${id}/adapterruns?limit=${limit}&offset=${offset}`);
	},
	findAdapterRun(id) {
		return axios.get(`/api/adapterruns/${id}`);
	},
};
